
const { doExec } = require('./request')

module.exports = {
    // 佛事相关接口
    foShi: {
        // 佛事分类列表
        list (opts) {
            return doExec('mobile/affairs/dailybuddhas/list', opts, null, 'get')
        },
        // 查询分类下面的内容列表
        getChildList (opts) {
            return doExec('mobile/affairs/dailybuddhas/listBuddhaLent', opts, null, 'get')
        },
        // 子内容详情
        getChildDetail (opts) {
            return doExec(`/mobile/affairs/dailybuddhas/getBuddhaLentDetail/${opts.id}`, opts, null, 'get')
        }
    },
    // 年度法会
    faHui: {
        // 法会列表
        list (opts) {
            return doExec('mobile/affairs/annCeremony/list', opts, null, 'get')
        },
        // 查询法会供奉详情
        getItemData (opts) {
            return doExec(`mobile/affairs/annCeremony/mAnnualCeremonyDetails/${opts.id}`, opts, null, 'get')
        },
        // 查询供奉牌位详情
        getSubDetail (opts) {
            return doExec(`mobile/affairs/annCeremony/mMemorialTablet/${opts.id}`, opts, null, 'get')
        },

    },
    // 愿生安养
    anYang: {
        // 安养列表
        list (opts) {
            return doExec('mobile/affairs/prayandbless/list', opts, null, 'get')
        }
    },
    // 广种福田
    fuTian: {
        // 广种福田列表
        list (opts) {
            return doExec('mobile/affairs/plantingwish/list', opts, null, 'get')
        },
        // 广种福田详情
        getDetail (opts) {
            return doExec(`mobile/affairs/plantingwish/getPlantingWishDetail/${opts.id}`, opts, null, 'get')
        },
        // 纪念日列表
        getAnniversaryList (opts) {
            return doExec('mobile/affairs/plantingwish/listAnniversary', opts, null, 'get')
        },
        // 林木列表
        getTreeList (opts) {
            return doExec('mobile/affairs/plantingwish/listTrees', opts, null, 'get')
        },
        //纪念日详情
        getDateData(opts) {
            return doExec(`mobile/affairs/plantingwish/anniversary/${opts.id}`, opts, null, 'get')
        },
        //林木详情
        getTreeData(opts) {
            return doExec(`mobile/affairs/plantingwish/tree/${opts.id}`, opts, null, 'get')
        }
    }
}